import { Button } from "../../design/components/Button";
import { Icon, type IconName } from "../../design/components/Icon";
import { useMenuButton } from "../../design/components/menu-button";
import { useT } from "../../i18n/locale";

// «Altro» nella testata della scheda (piano M6, R1, Task 4a; ruling A4, questione 390). La colonna delle azioni ha un tetto: in
// vista restano sempre «Chiama» e «WhatsApp», e gli altri pulsanti, quando la scheda è più stretta delle sue tre aree (accanto alla
// rail fissa a 1280 px), passano in questo menu nell'ordine della testata. Lo decide il CSS (`lead-card.css`, container query):
// i pulsanti stanno sempre nella pagina e quelli che non ci stanno si nascondono, «Altro» compare soltanto allora. Tastiera e
// fuoco sono quelli di «Altro» delle Smart List (`useMenuButton`); una voce scelta chiude il menu e ridà il fuoco ad «Altro», a
// cui torna anche la finestra che apre.

/** Un'azione della testata: la stessa, in riga e nel menu. */
export type HeaderAction = {
  key: string;
  label: string;
  icon: IconName;
  /** Apre una finestra (`aria-haspopup="dialog"`). */
  opensDialog?: boolean;
  onSelect: () => void;
};

export function LeadHeaderMore({ actions }: { actions: readonly HeaderAction[] }) {
  const t = useT();
  const { open, close, wrapperRef, buttonRef, menuRef, buttonProps, menuProps } = useMenuButton();

  function choose(action: HeaderAction) {
    close(true);
    action.onSelect();
  }

  return (
    <span className="g-lead-head__more" ref={wrapperRef}>
      <Button ref={buttonRef} {...buttonProps}>
        {t("leadCard.more")}
        <Icon name="down" />
      </Button>
      {open ? (
        <div ref={menuRef} {...menuProps} aria-label={t("leadCard.moreLabel")} className="g-lead-head__menu">
          {actions.map((action) => (
            <button
              key={action.key}
              type="button"
              role="menuitem"
              className="g-lead-head__menu-item"
              aria-haspopup={action.opensDialog ? "dialog" : undefined}
              onClick={() => choose(action)}
            >
              <Icon name={action.icon} />
              {action.label}
            </button>
          ))}
        </div>
      ) : null}
    </span>
  );
}
